module.exports = __webpack_public_path__ + "components/intersport-discount-page/static/intersport-2@2-bd8483c2621477682393551ba4114908.jpg";